import React, { useEffect, useState } from "react";
import LoadingBar from "react-top-loading-bar";
import { AppRouteUi, CallCenterActivityTypeOptions, ExportTableType, PaginationSettings, topLoaderProgress, } from "../../configs";
import { AdminPageTemplate, ColumnToolTip, ModalCallSummary, } from "../../features";
import { useFunctionalityCallCenterStatus } from "../hooks/functionalityCallCenterStatus";
import { useAppSelector, VRIAppStateType } from "../../core";
import ReactDOM from "react-dom";
import { ColumnSelectionsModel, TableColumnExtend } from "../../models";
import { CallCenterStatusColumns } from "../../configs/AppJson/CallCenterStatusColumns";
import moment from "moment";
import { ApiSchemaFilter } from "../../models/api/filter";
import { ApiSchemaCallCenterStatusData } from "../../models/api/CallCenterStatus";
import { Link } from 'react-router-dom';
import { CallSummaryResponseModel } from "../../models/api/Call";
import { useFunctionalityCallSummary } from "../hooks";
import { AssetSvg } from "../../assets";

export function PageStatus() {
  const callCenterId = useAppSelector(
    (state: VRIAppStateType) => state.auth.menuSettings?.callCenterSettings.callCenterId
  );
  const [show, setShow] = useState<boolean>(false);
  const [callSummaryData, setCallSummaryData] = useState<CallSummaryResponseModel>();
  const { LoadById } = useFunctionalityCallSummary();
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [isShowCommonFilter, setIsShowCommonFilter] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);
  const [columnSelection, setColumnSelection] = useState<ColumnSelectionsModel[]>(CallCenterStatusColumns);
  const [columnSelectionModalShow, setColumnSelectionModalShow] = React.useState(false);

  let initialFilterData: ApiSchemaFilter = {
    filterQueries: [],
    sortQuery: {},
  };
  const [filterData, setFilterData] = useState<ApiSchemaFilter>(initialFilterData);
  const [filterDataChange, setFilterDataChange] = useState<number>(0);
  const [fetchIsStale, setFetchIsStale] = useState(false);

  const {
    pagedStatusList,
    pagedStatusListCount,
    pagedCallCenterStatusUrl,
    lastUpdated
  } = useFunctionalityCallCenterStatus({
    callCenterId: callCenterId || "",
    pageSize: pageSize,
    pageNo: pageIndex,
    searchText: searchText?.trimStart(),
    setLoaderProgress,
    filterData: filterData,
    filterDataChange: filterDataChange,
  });

  useEffect(() => {
    if (pagedStatusListCount) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedStatusList]);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const handleShowCallSummary = (callId: string) => {
    if (callId) {
      setLoaderProgress(topLoaderProgress.start);
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>> LoadbyId from StatusPage");
      LoadById(callId).then((data) => {
        if (data?.id) {
          setLoaderProgress(topLoaderProgress.complete);
          setCallSummaryData(data);
          setShow(true);
        }
      });
    }
  };

  const fromOADate = (oadate: number) => {
    const millis = (oadate - 25569) * 86400000;

    const tzOffset = new Date().getTimezoneOffset() * 60000;

    return new Date(millis + tzOffset);
  };

  function secondsToHms(seconds: number) {
    if (seconds == null || isNaN(seconds)) return "00:00:00";
    const totalSeconds = Math.floor(seconds * 86400);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (n: number) => n.toString().padStart(2, "0");

    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  }


  function formatDate(date: Date | null): string {
    if (date == null) {
      return "loading"
    }
    else {
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).replace(",", "");
    }
  }

    useEffect(() => {
      console.log("loading value", loaderProgress);
  
    }, [loaderProgress])

  useEffect(() => {
    const interval = setInterval(() => {
      if (!lastUpdated) return;

      const now = new Date();
      const diffInSeconds = (now.getTime() - lastUpdated.getTime()) / 1000;

      setFetchIsStale(diffInSeconds > 20);
    }, 2000);

    return () => clearInterval(interval);
  }, [lastUpdated]);

  const statusTableColumns: TableColumnExtend<ApiSchemaCallCenterStatusData>[] =
    [
      {
        name: <ColumnToolTip data="Name" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          return (
            <Link to={AppRouteUi.Operator.Profile.Load(row.operatorId ?? "")}>
              <ColumnToolTip data={row.name ?? ""} />
            </Link>
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Name")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Email" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          return <ColumnToolTip data={row.email ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Email")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Platform Type" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          return <ColumnToolTip data={row.platformtype ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "PlatformType")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Status" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          let label = "-";
          if (row?.activity === 1) label = "Online";
          else if (row?.activity === 3) label = "In Call";
          else if (row?.activity === 11) label = "Busy";

          return (
            <div className={`colored-pill-text status-${row.activity}`}>
              {label}
            </div>
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Status")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Call Id" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          return <ColumnToolTip data={row.callId ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallId")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Device" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          return <ColumnToolTip data={row.device ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Device")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Start Time" />,
        //the received data is already sorted by start time, and there is no other sorting enabled so it won't need to be resorted
        sortable: false,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          const date = row.startTime ? row.startTime : null;
          return (
            <ColumnToolTip
              data={date ? moment(date).format("MMM DD, YYYY HH:mm:ss") : "-"}
            />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "StartTime")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="End Time" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {
          const date = row.endTime ? row.endTime : null;

          return (
            <ColumnToolTip
              data={date ? moment(date).format("MMM DD, YYYY HH:mm:ss") : "-"}
            />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "EndTime")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Interval" />,
        selector: (row: ApiSchemaCallCenterStatusData) => {

          return (
            <ColumnToolTip
              data={row.intervalTime ? secondsToHms(row.intervalTime) : "-"}
            />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "IntervalTime")?.isEnabled ? false : true,
      },
      // {
      //   name: <ColumnToolTip data="Details" />,
      //   selector: (row: ApiSchemaCallCenterStatusData) => (
      //     <>
      //       {row.callId && (
      //         <div
      //           className="btn svg-color"
      //           title="Edit"
      //           onClick={() => handleShowCallSummary(row.callId ?? "")}
      //         >
      //           <span >
      //             <AssetSvg.ViewProfile />
      //           </span>
      //         </div>
      //       )}
      //       {row.description && (
      //         <ColumnToolTip
      //           data={
      //             row.description
      //           }
      //         />
      //       )}
      //     </>
      //   ),
      //   omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Details")?.isEnabled ? false : true,
      // },
    ];
  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />

      <div className="d-flex align-items-end justify-content-end">
        <small style={{ color: fetchIsStale ? "red" : "grey" }}>Last fetched on: {formatDate(lastUpdated)}</small>
      </div>
      <AdminPageTemplate
        pagingKey="PageStatus"
        loaderProgress={loaderProgress}
        showExportOptions={true}
        showFilter={true}
        filterPanel={"commonAuditActivityFilterPanel"}
        pageBreadCrumbTile="Call Center"
        pageTitle="Status"
        tableHeaders={statusTableColumns}
        tableData={pagedStatusList || []}
        searchText={searchText}
        handleSearch={handleSearch}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        count={pagedStatusListCount}
        onChangePageIndex={onChangePageIndex}
        onChangePageSize={onChangePageSize}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
        columnSelectionModalShow={columnSelectionModalShow}
        setColumnSelectionModalShow={setColumnSelectionModalShow}
        columnSelection={columnSelection}
        setColumnSelection={setColumnSelection}
        setFilterDataForAnyTable={setFilterData}
        setFilterDataChangeForAnyTable={setFilterDataChange}
        pageName="statusPage"
        tableType={ExportTableType.CallCenterStatusLog}
        downloadedFileName={"CallCenterStatusLog Report"}
        callCenterId={callCenterId}
        filterData={filterData}
        setLoaderProgress={setLoaderProgress}
        showAutoRefresh={true}
        mutateUrl={pagedCallCenterStatusUrl}
        setIsShowCommonFilter={setIsShowCommonFilter}
        isShowCommonFilter={isShowCommonFilter}
      />
      <ModalCallSummary
        summary={callSummaryData}
        show={show}
        handleShow={setShow}
      />
    </>
  );
}
